// import '../../styles/modules/institutions/_org_user_search.scss';

/* @ngInject */
export default function OrgUsersSearchCtrl(
  _,
  $state,
  $stateParams,
  InstitutionsManager,
  nvCurrentPage,
) {
  class OrgUsersSearchController {
    constructor() {
      this.users = [];
      this.queryParams = ['query'];
      this.searchQuery = $stateParams.query;

      this.requestDataPage = (pageIndex, pageSize) => InstitutionsManager.orgDashboardUserSearch(
        pageIndex,
        pageSize,
        $stateParams.query,
      );
    }

    // eslint-disable-next-line class-methods-use-this
    resetSearch() {
      $stateParams.query = '';
      $state.go('license-dashboard');
    }

    // eslint-disable-next-line class-methods-use-this
    viewUserDetails(user) {
      $state.go('org-user-details-modal', {
        userId: user.id,
        institutionId: nvCurrentPage.getInstitution().id,
      });
    }
  }

  return new OrgUsersSearchController();
}
